import React from "react"
import Badge from "./badge";

class BadgesCandidate extends React.Component {
    render() {
        const { progress_states } = this.props;
        return (
            <div className='trophies-list'>
                <Badge identifier='Badges::Candidate::ContentUnits' code='elektrizujici_vykon' progress_states={progress_states} />
                <Badge identifier='Badges::Candidate::ImportantDocuments' code='nezdolna_energie' progress_states={progress_states} />
                <Badge identifier='Badges::Candidate::Articles' code='zapaleny_ctenar' progress_states={progress_states}/>
                <Badge identifier='Badges::Candidate::PersonalForm' code='mas_jiskru' progress_states={progress_states}/>
                <Badge identifier='Badges::Candidate::ActivityFirst' code='jizda_pod_plynem' progress_states={progress_states}/>
                <Badge identifier='Badges::Candidate::ActivitySecond' code='s_plynem_na_podlaze' progress_states={progress_states}/>
                <Badge identifier='Badges::Candidate::LifeAtInnogy' code='pali_ti_to' progress_states={progress_states}/>
                <Badge identifier='Badges::Candidate::MedicalExam' code='mas_stavu' progress_states={progress_states}/>
            </div>
        )
    };
}

export default BadgesCandidate;
